
$(document).ready(() => {
    if ($('header.position-sticky').length || $('.sticky-top-most .navbar').length) {
        const $headerBtn = $('.sticky-top-most .navbar .wp-block-button > a').length && $('.sticky-top-most .navbar .wp-block-button > a') || $('header .nav-item.btn');
        $(window).on('scroll', () => {
            const scrollVal = $('body').attr('data-last-scroll');
            if (scrollVal > 800) {
                $headerBtn.removeClass('d-none').addClass('d-block')
            } else {
                $headerBtn.removeClass('d-block').addClass('d-none');
            }
        });
    }
})

